import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "color", "display", "fontSize", "lineHeight", "fontWeight", "letterSpacing", "ellipsis", "rowEllipsis", "textIndent", "textAlign", "textShadow", "userSelect", "verticalAlign", "whiteSpace", "wordWrap", "textDecoration", "textTransform", "children"];
/* LIBRARIES */
import * as React from 'react';
import { clsx as cx } from 'clsx';
/* STYLES */
import * as styles from '../styles/common.module.css';
import * as displayStyles from '../../../../internal/styles/display.module.css';
import * as colorsStyles from '../../../../colors/colors.module.css';
import * as constantColorsStyles from '../../../../colors/constant/colors.module.css';
import * as typographyStyles from '../../../sizes.module.css';
import * as userSelectStyles from '../../../../internal/styles/userSelect.module.css';
/* TYPES */

/**
 *
 * Компонент `Text`. Предназначен для отображения любого текста.
 * <br/>
 * Имеет различные настройки отображения типографики.
 * <br/>
 * Самостоятельное использование текста заприщено.
 */
var TextComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _cx;
  var as = props.as,
    color = props.color,
    display = props.display,
    fontSize = props.fontSize,
    lineHeight = props.lineHeight,
    fontWeight = props.fontWeight,
    letterSpacing = props.letterSpacing,
    ellipsis = props.ellipsis,
    rowEllipsis = props.rowEllipsis,
    textIndent = props.textIndent,
    textAlign = props.textAlign,
    textShadow = props.textShadow,
    userSelect = props.userSelect,
    verticalAlign = props.verticalAlign,
    whiteSpace = props.whiteSpace,
    wordWrap = props.wordWrap,
    textDecoration = props.textDecoration,
    textTransform = props.textTransform,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var TagName = as;
  var letterSpacingClassName = styles["text_letterSpacing__".concat(letterSpacing)];
  return /*#__PURE__*/React.createElement(TagName, _extends({}, rest, {
    ref: ref,
    style: {
      letterSpacing: letterSpacingClassName ? null : letterSpacing,
      textShadow: textShadow,
      textIndent: textIndent
    },
    className: cx(colorsStyles["color_".concat(color)], constantColorsStyles["color_".concat(color)], typographyStyles["lineHeight_".concat(lineHeight)], typographyStyles["fontWeight_".concat(fontWeight)], typographyStyles["fontSize_".concat(fontSize)], displayStyles["display_".concat(display)], styles['text'], styles["fontWeight__".concat(fontWeight)], letterSpacingClassName, (_cx = {}, _defineProperty(_cx, userSelectStyles["userSelect_".concat(userSelect)], userSelect), _defineProperty(_cx, styles["text_textDecoration__".concat(textDecoration)], textDecoration), _defineProperty(_cx, styles["text_textTransform__".concat(textTransform)], textTransform), _defineProperty(_cx, styles["text_rowEllipsis__".concat(rowEllipsis)], rowEllipsis), _defineProperty(_cx, styles['text_rowEllipsis'], rowEllipsis), _defineProperty(_cx, styles['text_ellipsis'], ellipsis), _defineProperty(_cx, styles["text_textAlign__".concat(textAlign)], textAlign), _defineProperty(_cx, styles["text_verticalAlign__".concat(verticalAlign)], verticalAlign), _defineProperty(_cx, styles["text_whiteSpace__".concat(whiteSpace)], whiteSpace), _defineProperty(_cx, styles["text_wordWrap__".concat(wordWrap)], wordWrap), _cx))
  }), children);
});
TextComponent.displayName = 'Text';
TextComponent.defaultProps = {
  as: 'span',
  color: 'black_100',
  display: 'inline-block',
  fontSize: '16px',
  fontWeight: 'normal',
  lineHeight: '22px',
  // TODO: удалить normal в пользу 0
  letterSpacing: 'normal'
};
export var Text = /*#__PURE__*/React.memo(TextComponent);